<template>
    <div class="frc" :class="{ 'frc--popup': formpopup }">
        <p v-if="!formpopup" class="frc-intro">
            {{ $t('post.page.racis.description') }}
        </p>

        <div class="frc-sections">
            <section class="frc-section frc-section--primary">
                <header class="frc-section-head">
                    <span class="frc-section-badge frc-section-badge--r">R</span>
                    <div class="frc-section-title">
                        <h3>{{ $t('post.page.racis.is_responsible') }}</h3>
                        <span class="frc-section-hint">Fait l'action</span>
                    </div>
                </header>
                <v-select
                    multiple
                    v-model="responsible"
                    :filterable="false"
                    :options="options"
                    label="name"
                    class="frc-select"
                    @search="onSearch"
                >
                    <template slot="no-options">
                        {{ $t('post.page.racis.searchuser') }}
                    </template>
                    <template slot="option" slot-scope="option">
                        <span>{{ option.name }}</span>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <span>{{ option.name }}</span>
                    </template>
                </v-select>
            </section>

            <section class="frc-section">
                <header class="frc-section-head">
                    <span class="frc-section-badge frc-section-badge--a">A</span>
                    <div class="frc-section-title">
                        <h3>{{ $t('post.page.racis.is_accountable') }}</h3>
                        <span class="frc-section-hint">Imputable — rend compte</span>
                    </div>
                </header>
                <v-select
                    multiple
                    v-model="accountable"
                    :filterable="false"
                    :options="options"
                    label="name"
                    class="frc-select"
                    @search="onSearch"
                >
                    <template slot="no-options">
                        {{ $t('post.page.racis.searchuser') }}
                    </template>
                    <template slot="option" slot-scope="option">
                        <span>{{ option.name }}</span>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <span>{{ option.name }}</span>
                    </template>
                </v-select>
            </section>

            <div class="frc-row">
                <section class="frc-section">
                    <header class="frc-section-head">
                        <span class="frc-section-badge frc-section-badge--c">C</span>
                        <div class="frc-section-title">
                            <h3>{{ $t('post.page.racis.editconsulted') }}</h3>
                            <span class="frc-section-hint">Consulté — donne un avis</span>
                        </div>
                    </header>
                    <v-select
                        multiple
                        v-model="consulted"
                        :filterable="false"
                        :options="options"
                        label="name"
                        class="frc-select"
                        @search="onSearch"
                    >
                        <template slot="no-options">
                            {{ $t('post.page.racis.searchuser') }}
                        </template>
                        <template slot="option" slot-scope="option">
                            <span>{{ option.name }}</span>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <span>{{ option.name }}</span>
                        </template>
                    </v-select>
                </section>

                <section class="frc-section">
                    <header class="frc-section-head">
                        <span class="frc-section-badge frc-section-badge--i">I</span>
                        <div class="frc-section-title">
                            <h3>{{ $t('post.page.racis.editinformed') }}</h3>
                            <span class="frc-section-hint">Informé — tenu au courant</span>
                        </div>
                    </header>
                    <v-select
                        multiple
                        v-model="informed"
                        :filterable="false"
                        :options="options"
                        label="name"
                        class="frc-select"
                        :clearable="false"
                        @search="onSearch"
                    >
                        <template slot="no-options">
                            {{ $t('post.page.racis.searchuser') }}
                        </template>
                        <template slot="option" slot-scope="option">
                            <span>{{ option.name }}</span>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <span>{{ option.name }}</span>
                        </template>
                    </v-select>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapState, mapActions } from 'vuex'

export default {
    name: 'FormRacisForm',
    props: ['editform', 'formpopup'],
    data() {
        return {
            options: [],
            loading: false,
            oldIsResponsible: null,
            oldIsAccountable: null,
            oldIsConsulted: [],
            oldIsInformed: [],
            result: [],
            iscreated: false,
            responsible: null,
            accountable: null,
            localRacis: []
        }
    },
    async created() {
        this.iscreated = true
        const formId = this.$route.params.formId
        if (formId) await this.editForm(formId)
        if (this.formpopup && this.post.racis) {
            this.localRacis = this.post.racis.map((u) => ({ ...u }))
        }
        if (this.racisresult) {
            this.responsible =
                this.userIsResponsible && this.userIsResponsible.length > 0
                    ? this.userIsResponsible
                    : null
            this.accountable =
                this.userIsAccountable && this.userIsAccountable.length > 0
                    ? this.userIsAccountable
                    : null
            this.oldIsConsulted = this.racisresult.filter((u) => u.is_consulted === 1)
            this.oldIsInformed = this.racisresult.filter((u) => u.is_informed === 1)
        }
    },
    watch: {
        responsible: function (newValue) {
            if (newValue) {
                if (
                    this.userIsResponsible &&
                    this.userIsResponsible.length > 0
                ) {
                    this.userIsResponsible.forEach((element) =>
                        this.changeRole(this.racisresult, element.id, 0)
                    )
                }

                newValue.map((value) => {
                    this.pushUsers(this.racisresult, value, 0)
                })
                this.oldIsResponsible = newValue
                return newValue
            } else {
                this.changeRole(this.racisresult, this.oldIsResponsible.id, 0)
                this.userIsResponsible.forEach((element) =>
                    this.changeRole(this.racisresult, element.id, 0)
                )
                return null
            }
        },
        accountable: function (newValue) {
            if (newValue) {
                if (
                    this.userIsAccountable &&
                    this.userIsAccountable.length > 0
                ) {
                    this.userIsAccountable.forEach((element) =>
                        this.changeRole(this.racisresult, element.id, 1)
                    )
                }
                newValue.map((value) => {
                    this.pushUsers(this.racisresult, value, 1)
                })
                this.oldIsAccountable = newValue
                return newValue
            } else {
                this.userIsAccountable.forEach((element) =>
                    this.changeRole(this.racisresult, element.id, 1)
                )
                this.changeRole(this.racisresult, this.oldIsAccountable.id, 1)
                return null
            }
        }
    },
    computed: {
        ...mapState('form', {
            form: (state) => state.newForm
        }),
        ...mapState('post', {
            post: (state) => state.post
        }),
        racisresult() {
            if (this.formpopup) {
                return this.localRacis
            } else {
                return this.form.racis && this.form.racis.length > 0
                    ? this.form.racis
                    : []
            }
        },
        userIsResponsible() {
            return this.racisresult.filter((user) => user.is_responsible === 1)
        },
        userIsAccountable() {
            return this.racisresult.filter((user) => user.is_accountable === 1)
        },
        consulted: {
            get() {
                if (this.iscreated) {
                    return this.racisresult.filter((user) => user.is_consulted === 1)
                }
                return []
            },
            set(newValue) {
                if (newValue) {
                    if (newValue.length > this.oldIsConsulted.length) {
                        newValue.forEach((element) => {
                            this.pushUsers(this.racisresult, element, 2)
                        })
                    } else if (newValue.length < this.oldIsConsulted.length) {
                        let deletevalue = this.oldIsConsulted.filter(
                            this.compare(newValue)
                        )
                        deletevalue.forEach((element) => {
                            this.changeRole(this.racisresult, element.id, 2)
                        })
                    }
                }
                this.oldIsConsulted = newValue
            }
        },
        informed: {
            get() {
                if (this.iscreated) {
                    return this.racisresult.filter((user) => user.is_informed === 1)
                }
                return []
            },
            set(newValue) {
                if (newValue) {
                    if (newValue.length > this.oldIsInformed.length) {
                        newValue.forEach((element) => {
                            this.pushUsers(this.racisresult, element, 3)
                        })
                    } else if (newValue.length < this.oldIsInformed.length) {
                        let deletevalue = this.oldIsInformed.filter(
                            this.compare(newValue)
                        )
                        deletevalue.forEach((element) => {
                            this.changeRole(this.racisresult, element.id, 3)
                        })
                    }
                }
                this.oldIsInformed = newValue
            }
        }
    },

    methods: {
        ...mapActions('auth', {
            searchUser: 'searchUser'
        }),
        ...mapActions('post', {
            updatePostRacis: 'updatePostRacis'
        }),
        ...mapActions('form', { editForm: 'editForm' }),
        onSearch(search, loading) {
            if (search.length) {
                loading(true)
                this.search(loading, search)
            }
        },
        compare(otherArray) {
            return function (current) {
                return (
                    otherArray.filter(function (other) {
                        return other.id == current.id
                    }).length == 0
                )
            }
        },
        search: function (loading, search) {
            this.searchUser(search).then((response) => {
                this.options = response.data.users.data
                loading(false)
            })
        },
        pushUsers(form, newValue, index) {
            if (!newValue.id) {
                newValue.id = newValue.id
            }
            if (newValue && newValue.id) {
                var i = form.findIndex((user) => user.id === newValue.id)
                this.pushUser(form, newValue, index, i)
            }
        },
        pushUser(form, newValue, index, i) {
            if (i === -1) {
                this.formatNewValue(newValue)
                this.applyRole(newValue, index, 1)
                form.push(newValue)
            } else {
                this.applyRole(form[i], index, 1)
            }
        },
        formatNewValue(newValue) {
            newValue = {
                id: newValue.id,
                name: newValue.name,
                user: {
                    name: newValue.name,
                    email: newValue.email,
                    job_title: newValue.job_title
                },
                is_responsible: 0,
                is_accountable: 0,
                is_consulted: 0,
                is_informed: 0
            }
        },
        addValue(value) {
            return value === 1 ? 1 : 0
        },
        applyRole(form, index, apply) {
            form.is_responsible = this.addValue(form.is_responsible)
            form.is_accountable = this.addValue(form.is_accountable)
            form.is_consulted = this.addValue(form.is_consulted)
            form.is_informed = this.addValue(form.is_informed)
            switch (index) {
                case 0:
                    form.is_responsible = apply
                    break
                case 1:
                    form.is_accountable = apply
                    break
                case 2:
                    form.is_consulted = apply
                    break
                case 3:
                    form.is_informed = apply
                    break
            }
        },
        changeRole(form, userid, index) {
            if (userid) {
                var i = form.findIndex((user) => user.id === userid)
                this.applyRole(form[i], index, 0)
                if (
                    form[i].is_responsible === 0 &&
                    form[i].is_accountable === 0 &&
                    form[i].is_consulted === 0 &&
                    form[i].is_informed === 0
                ) {
                    form.splice(i, 1)
                }
            }
        },
        cancel: function () {
            this.$emit('cancel')
        },
        update: function () {
            const id = this.$route.params.id
            this.loading = true
            return this.updatePostRacis({ id, data: { racis: this.racisresult } })
                .then(() => {
                    this.$emit('get-post-data')
                    this.$emit('saved')
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style scoped>
.frc {
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.frc-intro {
    margin: 0 0 var(--v2-space-4);
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
}

.frc--popup .frc-sections {
    gap: var(--v2-space-4);
}

.frc-sections {
    display: flex;
    flex-direction: column;
    gap: var(--v2-space-5);
}

.frc-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--v2-space-4);
}

.frc-section {
    display: flex;
    flex-direction: column;
    gap: var(--v2-space-2);
}

.frc-section-head {
    display: flex;
    align-items: center;
    gap: var(--v2-space-3);
}

.frc-section-badge {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: var(--v2-font-weight-bold);
    flex-shrink: 0;
}

.frc-section-badge--r {
    background: rgba(8, 145, 178, 0.12);
    color: #0891B2;
}

.frc-section-badge--a {
    background: rgba(245, 158, 11, 0.14);
    color: #b45309;
}

.frc-section-badge--c {
    background: rgba(16, 185, 129, 0.12);
    color: #047857;
}

.frc-section-badge--i {
    background: rgba(148, 163, 184, 0.18);
    color: #475569;
}

.frc-section--primary .frc-section-badge {
    width: 34px;
    height: 34px;
    font-size: 0.95rem;
}

.frc-section-title {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
}

.frc-section-title h3 {
    margin: 0;
    font-size: 0.92rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
    line-height: 1.25;
}

.frc-section--primary .frc-section-title h3 {
    font-size: 1rem;
    color: #0891B2;
}

.frc-section-hint {
    font-size: 0.72rem;
    color: var(--v2-text-4);
    line-height: 1.3;
}

.frc-select {
    width: 100%;
}

@media (max-width: 720px) {
    .frc-row {
        grid-template-columns: 1fr;
    }
}
</style>
